
import { IReportListResponse } from '../../Interfaces/IReports';

export enum ReportsActionType {
  REQUEST_REPORT_LIST = 'REQUEST_REPORT_LIST',
  RECEIVE_REPORT_LIST = 'RECEIVE_REPORT_LIST',
  RECEIVE_REPORT_LIST_ERROR = 'RECEIVE_REPORT_LIST_ERROR',
}

export type ReportsAction = IRequestReportListAction | IReceiveReportListAction | IReceiveReportListErrorAction;

export interface IRequestReportListAction {
  type: ReportsActionType.REQUEST_REPORT_LIST;
}

export interface IReceiveReportListAction {
  type: ReportsActionType.RECEIVE_REPORT_LIST;
  data: IReportListResponse[];
}

export interface IReceiveReportListErrorAction {
  type: ReportsActionType.RECEIVE_REPORT_LIST_ERROR;
  errorMessage: string;
}